import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync, GenericDropDownV3, Show, TS_MultiSelect_V2 } from '@nu-art/thunderstorm-frontend/index';
import { ModuleFE_Variable } from './ModuleFE_Variable.js';
import { DBItemDropDownMultiSelector } from '@nu-art/thunderstorm-frontend/components/_TS_MultiSelect/DBItemDropDownMultiSelector';
import { ICONS } from '@app/styles';
import { DropDown_DefaultCaret } from '@app/styles/frontend/ui/consts';
import { VariableWrapper } from '../../wrappers/index.js';
export const Props_VariableDropDownV3 = {
    module: ModuleFE_Variable,
    modules: [ModuleFE_Variable],
    mapper: item => new VariableWrapper(item).getSearchableText(),
    placeholder: 'Choose a Variable',
    renderer: item => _jsx(_Fragment, { children: item.name }),
    caret: DropDown_DefaultCaret,
};
export const Props_VariableDropDownV3WithSynonyms = {
    ...Props_VariableDropDownV3,
    selectedItemRenderer: (item) => _jsx("div", { style: { color: !item ? 'red' : 'inherit' }, className: 'ts-dropdown__selected', children: item?.name ?? 'Entity Not Found' }),
    renderer: item => _jsxs(_Fragment, { children: [item.name, new VariableWrapper(item).getNlpData()?.synonyms.length ? _jsxs("div", { style: { fontSize: 12 }, children: ["(", new VariableWrapper(item).getNlpData()?.synonyms.join(', '), ")"] }) : null] })
};
export const DropDown_VariableV3WithSynonyms = GenericDropDownV3.prepare(Props_VariableDropDownV3WithSynonyms);
class ReactiveDropDown_VariableV3WithSynonyms_Class extends ComponentSync {
    __onVariableUpdated(...params) {
        this.forceUpdate();
    }
    deriveStateFromProps(nextProps, state) {
        // Track selected ID in state so shouldComponentUpdate detects changes
        state.selectedId = nextProps.editable.item[nextProps.prop];
        return state;
    }
    render() {
        return _jsx(DropDown_VariableV3WithSynonyms.editable, { ...this.props });
    }
}
export const ReactiveDropDown_VariableV3WithSynonyms = {
    editable: (props) => _jsx(ReactiveDropDown_VariableV3WithSynonyms_Class, { ...props })
};
export const DropDown_VariableV3 = GenericDropDownV3.prepare(Props_VariableDropDownV3);
const Props_MultiSelect = DBItemDropDownMultiSelector.propsV3({
    module: ModuleFE_Variable,
    itemRenderer: (item, onDelete, disabled) => {
        if (!item)
            return _jsx(_Fragment, { children: "Not Found" });
        return _jsxs(Show, { children: [_jsx(Show.If, { condition: !disabled, children: _jsx(ICONS.x.component, { onClick: onDelete, className: 'ts-icon__small' }) }), _jsx(Show.If, { condition: true, children: item.name })] });
    },
    uiSelector: DropDown_VariableV3.selectable,
});
export const MultiSelect_Variable = TS_MultiSelect_V2.prepare(Props_MultiSelect);
const mandatoryProps = { ...Props_VariableDropDownV3, renderer: (item) => _jsx(_Fragment, { children: item.name }) };
export const DropDown_Variables = GenericDropDownV3.prepareEditable(mandatoryProps);
//# sourceMappingURL=ui-components.js.map